import React, { useEffect, useState, useRef } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import "../../../admin_resources/css/admin_layout.css";
import "../../../admin_resources/css/admin_common.css";
import "../../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "../Admin_Header";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ko } from "date-fns/locale"; // 한국어 locale 추가
import { registerLocale } from "react-datepicker";

registerLocale("ko", ko); // 한국어 locale 등록

const Admin_PView = () => {
  const { idx } = useParams();
  const [popupsItem, setPopupsItem] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [, setPopupsList] = useState([]); //  목록 상태 추가
  const navigate = useNavigate(); // 삭제 후 목록으로 리다이렉트할 때 사용

  const [, setSelectedFileName] = useState(""); // file2의 선택된 파일 이름
  const [, setFile1Name] = useState(""); // file1 이름 상태
  const [file2, setFile2] = useState(null);
  
  const [permissions, setPermissions] = useState({});

  // useRef를 컴포넌트 최상위에서 호출
  const fileInputRef = useRef(null); // useRef로 파일 입력란에 대한 참조를 생성

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 관리자 페이지`;

    const fetchBanner = async () => {
      try {
        const response = await axios.get("/bplist");
        const banners = response.data;
        const selectBanner = banners.find(
          (banner) => banner.idx === parseInt(idx)
        );
        setPopupsItem(selectBanner);
        setStartDate(new Date(selectBanner.popStart));
        setEndDate(new Date(selectBanner.popEnd));
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };

    fetchBanner();

	  // 관리자 권한 정보 가져오기
	  const adminId = localStorage.getItem("adminId");
	  if (adminId) {
	    fetchPermissions(adminId);
	  }
	}, [idx]);

	const fetchPermissions = async (adminId) => {
	  try {
	    const response = await fetch(`/permissions/${adminId}`); // 권한 확인 API 호출
	    const data = await response.json();
	    setPermissions(data); // 권한 정보를 상태로 설정
	  } catch (error) {
	    console.error("권한 정보를 가져오는 데 실패했습니다.", error);
	  }
	};

  // 삭제 요청을 처리하는 함수
  const handleDelete = async () => {
    // 사용자가 정말로 삭제할 것인지 확인하는 창
    if (window.confirm("삭제하시겠습니까?")) {
      try {
        const response = await axios.delete(`/bp_delete/${popupsItem.idx}`);
        if (response.status === 200) {
          alert("삭제되었습니다.");

          // 삭제 후 팝업 목록을 갱신
          setPopupsList((prevList) =>
            prevList.filter((popup) => popup.idx !== popupsItem.idx)
          );

          // 삭제 후 목록 페이지로 이동
          navigate("/admin/site/popup");
        }
      } catch (error) {
        console.error("팝업 삭제 실패:", error);
        alert("팝업 삭제에 실패했습니다.");
      }
    }
  };

  if (!popupsItem) {
    return <div>로딩 중...</div>;
  }

  const handleStartDateChange = (date) => {
    setStartDate(date);
    setPopupsItem((prev) => ({
      ...prev,
      popStart: date.toISOString().split("T")[0],
    }));
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    setPopupsItem((prev) => ({
      ...prev,
      popEnd: date.toISOString().split("T")[0],
    }));
  };

  const hoursOptions = Array.from({ length: 24 }, (_, i) => (
    <option key={i} value={i < 10 ? `0${i}` : i}>
      {i < 10 ? `0${i}` : i}
    </option>
  ));

  const minutesOptions = Array.from({ length: 6 }, (_, i) => {
    const value = i * 10;
    const formattedValue = value < 10 ? `0${value}` : `${value}`;
    return (
      <option key={i} value={formattedValue}>
        {formattedValue}
      </option>
    );
  });

  const handleUpdate = async () => {
    // 수정 확인 알림창
    const isConfirmed = window.confirm("수정하시겠습니까?");

    if (!isConfirmed) {
      return; // 사용자가 취소를 선택하면 폼 제출을 중단
    }

    const formData = new FormData();
    formData.append("id", localStorage.getItem("adminId"));
    formData.append("name", localStorage.getItem("adminName"));
    formData.append("title", popupsItem.title);
    formData.append("url1", popupsItem.url1 || "");
    formData.append("target", popupsItem.target);
    formData.append("useYn", popupsItem.useYn);
    formData.append("popStart", popupsItem.popStart);
    formData.append("popShour", popupsItem.popShour);
    formData.append("popSmin", popupsItem.popSmin);
    formData.append("popEnd", popupsItem.popEnd);
    formData.append("popEhour", popupsItem.popEhour);
    formData.append("popEmin", popupsItem.popEmin);

    if (file2) {
      formData.append("file2", file2);
    }

    // 요청 전에 URL을 로그로 확인
    console.log(`/bp_update/${popupsItem.idx}`);

    try {
      const response = await axios.put(
        `/bp_update/${popupsItem.idx}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200) {
        alert("팝업이 수정되었습니다.");
        window.location.href = "/admin/site/popup";
      }
    } catch (error) {
      console.error("팝업 수정 실패:", error);
      alert("팝업 수정에 실패했습니다.");
    }
  };

  // 이미지 크기 체크 함수
  const checkImageSize = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        if (img.width === 500 && img.height === 500) {
          resolve();
        } else {
          reject("이미지 크기는 500x500이어야 합니다.");
        }
      };
      img.onerror = function () {
        reject("이미지 로드 오류");
      };
      img.src = URL.createObjectURL(file);
    });
  };

  // 파일 선택 함수
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    // 파일이 선택되었을 때
    if (file) {
      setSelectedFileName(file.name);
      const timestamp = new Date()
        .toISOString()
        .replace(/[-:.T]/g, "")
        .slice(0, 14);
      const extension = file.name.split(".").pop();
      setFile1Name(`${timestamp}_.${extension}`); // file1 이름 상태 업데이트
      setFile2(file); // file2 상태 업데이트

      // 이미지 크기 체크
      checkImageSize(file)
        .then(() => {
          console.log("이미지 크기 확인 통과");
        })
        .catch((errorMessage) => {
          alert(errorMessage); // 크기가 맞지 않으면 알림 띄우기
          setFile2(null); // 잘못된 파일을 상태에서 제거
          setSelectedFileName(""); // 파일 이름 초기화
          // 파일 입력란을 초기화
          fileInputRef.current.value = ""; // useRef로 파일 입력란 초기화
        });
    } else {
      setSelectedFileName("");
      setFile1Name(""); // 파일이 선택되지 않은 경우
      setFile2(null); // 잘못된 파일 상태 초기화

      // 파일 입력란 초기화
      fileInputRef.current.value = ""; // useRef로 파일 입력란 초기화
    }
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="admin_view">
        <div className="path-sec">
          HOME &gt; <span className="menu1">사이트 관리</span> &gt;
          <span className="menu2"> 팝업배너 관리</span>
        </div>
        <table>
          <tr>
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">사이트 관리</h3>
                <ul className="snb_list">
				{permissions.banner && (
				  <li>
				    <a href="/admin/site/banner">메인배너 관리</a>
				  </li>
				)}
				{permissions.popup && (
				  <li className="cur">
				    <a href="/admin/site/popup">팝업배너 관리</a>
				  </li>
				)}
                </ul>
              </div>
            </td>
            <td>
              <div className="bx-top">팝업 상세</div>
              <form id="editform">
                <div className="tb_01 wr">
                  <table>
                    <tbody>
                      <tr>
                        <th>제목</th>
                        <td>
                          <input
                            name="titie"
                            value={popupsItem.title}
                            type="text"
                            placeholder="여기에 제목을 입력하세요"
                            onChange={(e) =>
                              setPopupsItem({
                                ...popupsItem,
                                title: e.target.value,
                              })
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>팝업 기간</th>
                        <td>
                          <div className="datepicker-wrapper">
                            <DatePicker
                              selected={startDate}
                              onChange={handleStartDateChange}
                              className="inputtext required"
                              dateFormat="yyyy-MM-dd"
                              locale="ko"
                              showYearDropdown
                              showMonthDropdown
                              yearDropdownItemNumber={15}
                              scrollableYearDropdown
                              showIcon
                              icon={
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="1em"
                                  height="1em"
                                  viewBox="0 0 48 48"
                                >
                                  <mask id="ipSApplication0">
                                    <g
                                      fill="none"
                                      stroke="#fff"
                                      strokeLinejoin="round"
                                      strokeWidth="4"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        d="M40.04 22v20h-32V22"
                                      ></path>
                                      <path
                                        fill="#fff"
                                        d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                                      ></path>
                                    </g>
                                  </mask>
                                  <path
                                    fill="currentColor"
                                    d="M0 0h48v48H0z"
                                    mask="url(#ipSApplication0)"
                                  ></path>
                                </svg>
                              }
                            />
                            <select
                              name="popShour"
                              id="popShour"
                              value={popupsItem.popShour}
                              onChange={(e) =>
                                setPopupsItem({
                                  ...popupsItem,
                                  popShour: e.target.value,
                                })
                              }
                            >
                              {hoursOptions}
                            </select>
                            시
                            <select
                              name="popSmin"
                              id="popSmin"
                              value={popupsItem.popSmin}
                              onChange={(e) =>
                                setPopupsItem({
                                  ...popupsItem,
                                  popSmin: e.target.value,
                                })
                              }
                            >
                              {minutesOptions}
                            </select>
                            분 ~{" "}
                            <DatePicker
                              selected={endDate}
                              onChange={handleEndDateChange}
                              className="inputtext required"
                              dateFormat="yyyy-MM-dd"
                              locale="ko"
                              showYearDropdown
                              showMonthDropdown
                              yearDropdownItemNumber={15}
                              scrollableYearDropdown
                              showIcon
                              icon={
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="1em"
                                  height="1em"
                                  viewBox="0 0 48 48"
                                >
                                  <mask id="ipSApplication0">
                                    <g
                                      fill="none"
                                      stroke="#fff"
                                      strokeLinejoin="round"
                                      strokeWidth="4"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        d="M40.04 22v20h-32V22"
                                      ></path>
                                      <path
                                        fill="#fff"
                                        d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                                      ></path>
                                    </g>
                                  </mask>
                                  <path
                                    fill="currentColor"
                                    d="M0 0h48v48H0z"
                                    mask="url(#ipSApplication0)"
                                  ></path>
                                </svg>
                              }
                            />
                            <select
                              name="popEhour"
                              id="popEhour"
                              value={popupsItem.popEhour}
                              onChange={(e) =>
                                setPopupsItem({
                                  ...popupsItem,
                                  popEhour: e.target.value,
                                })
                              }
                            >
                              {hoursOptions}
                            </select>
                            시
                            <select
                              name="popEmin"
                              id="popEmin"
                              value={popupsItem.popEmin}
                              onChange={(e) =>
                                setPopupsItem({
                                  ...popupsItem,
                                  popEmin: e.target.value,
                                })
                              }
                            >
                              {minutesOptions}
                            </select>
                            분
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>현재 팝업 이미지</th>
                        <td>
                          {" "}
                          <img
                            src={`/static/DATA/banner/${popupsItem.file1}`}
                            alt={popupsItem.title}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>팝업 이미지</th>
                        <td id="fd">
                          <input
                            id="upload"
                            name="file2"
                            type="file"
                            className="inputtext"
                            onChange={handleFileChange}
                            ref={fileInputRef} // ref를 통해 입력 필드에 접근
                          />
                          현재 이미지 :{" "}
                          {popupsItem.file2
                            ? popupsItem.file2
                            : "이미지가 없습니다."}
                          <ul>
                            <li>※ 첨부파일 500px X 500px</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <th>링크</th>
                        <td>
                          <input
                            name="url1"
                            value={popupsItem.url1}
                            type="text"
                            onChange={(e) =>
                              setPopupsItem({
                                ...popupsItem,
                                url1: e.target.value,
                              })
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>브라우저</th>
                        <td>
                          <label>
                            <input
                              type="radio"
                              name="pop_new_w"
                              value="_self"
                              checked={popupsItem.target === "_self"}
                              onChange={() =>
                                setPopupsItem({
                                  ...popupsItem,
                                  target: "_self",
                                })
                              }
                            />
                            현재 창
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="pop_new_w"
                              value="_blank"
                              checked={popupsItem.target === "_blank"}
                              onChange={() =>
                                setPopupsItem({
                                  ...popupsItem,
                                  target: "_blank",
                                })
                              }
                            />
                            새 창
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <th>사용 여부</th>
                        <td>
                          <label>
                            <input
                              type="radio"
                              name="use_yn"
                              value="Y"
                              checked={popupsItem.useYn === "Y"}
                              onChange={() =>
                                setPopupsItem({ ...popupsItem, useYn: "Y" })
                              }
                            />
                            사용함
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="use_yn"
                              value="N"
                              checked={popupsItem.useYn === "N"}
                              onChange={() =>
                                setPopupsItem({ ...popupsItem, useYn: "N" })
                              }
                            />
                            사용안함
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </form>
              <div className="view-btn">
                <span className="btn custom_s">
                  <button>
                    <Link to="/admin/site/popup" style={{ color: "#fff" }}>
                      목록
                    </Link>
                  </button>
                </span>

                <div className="btn-right">
                  <span className="btn custom_r">
                    <button onClick={handleUpdate}>수정</button>
                  </span>
                  <span className="btn custom_d">
                    <button onClick={handleDelete}>삭제</button>
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default Admin_PView;
